module.exports = __webpack_public_path__ + "img/icon08.9ad81e55.png";